import script from "./CoreProgramExpensesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramExpensesView.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramExpensesView.vue?vue&type=style&index=0&id=5ded5130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ded5130"]])

export default __exports__